/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Picker_Add_AdultInputs */

const en_guest_picker_add_adult = /** @type {(inputs: Guest_Picker_Add_AdultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add adult`)
};

/**
* | output |
* | --- |
* | "Add adult" |
*
* @param {Guest_Picker_Add_AdultInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guest_picker_add_adult = /** @type {((inputs?: Guest_Picker_Add_AdultInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Picker_Add_AdultInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guest_picker_add_adult(inputs)
});